<div class="toast-container position-fixed top-0 end-0 p-3 app-toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <ngb-toast
      [class]="toastClass(toast)"
      [autohide]="true"
      [delay]="toast.delay"
      (hidden)="toastService.remove(toast.id)"
    >
      <div class="d-flex align-items-start gap-2 text-start">
        <app-icon
          [icon]="toastIcon(toast)"
          class="fs-lg flex-shrink-0 mt-1"
        />
        <div>
          <div class="fw-semibold">{{ toast.title }}</div>
          @if (toast.description) {
            <div>{{ toast.description }}</div>
          }
        </div>
      </div>
    </ngb-toast>
  }
</div>
